export default () => {
	const btt = document.getElementById("btt");
	var scrollTop =
		window.pageYOffset ||
		(document.documentElement || document.body.parentNode || document.body)
			.scrollTop;

    if (typeof(btt) != 'undefined' && btt != null) {
        btt.addEventListener("click", (e) => {
            window.scrollTo({ top: 0, behavior: "smooth" });
        });

        window.addEventListener("scroll", (e) => {
            scrollTop =
                window.pageYOffset ||
                (
                    document.documentElement ||
                    document.body.parentNode ||
                    document.body
                ).scrollTop;
            if (scrollTop > 1000) {
                btt.style.transform = "translateX(0)";
            } else {
                btt.style.transform = "translateX(calc(100% + 15px))";
            }
        });
    }


};
